import { graphql } from "relay-runtime"

export const deUpdateProgressNotePointOfCare = graphql`
  mutation deUpdateProgressNotePointOfCareMutation($input: De_updateProgressNotePointOfCareInput!) {
    updateProgressNotePointOfCare: de_updateProgressNotePointOfCare(input: $input) {
      ProgressNoteMutationOutput: de_ProgressNoteMutationOutput {
        episodeOfCare {
          id
          updatedAt
        }
        progressNote {
          updatedAt
          betterDoc {
            rejectionReason
          }
          pointOfCare {
            medical
            actual
            reasonForChoosingActual
            isDoctorVisitAvoided
            careProviderId
            purpose {
              physicalExam
              laboratory
              instrumentalExamination
            }
            specialtyId
            pointOfCareSpecialty {
              id
              word
              synonym
              specialtyTranslations {
                language
                name
              }
              betterDocKey
            }
            timeToTreatType
          }
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
